import { useMemo } from "react";

import { useFeaturedCities } from "./useFeaturedCities";

/**
 * Prefer geographically ordered featured cities from the API; otherwise the
 * first `limit` entries from the provided full list (typically population order).
 *
 * `initialData` court-circuite l'attente réseau : sur les routes `/cours/*`, le
 * rendu serveur résout déjà les villes voisines et les sérialise dans le HTML.
 * Sans cette graine, le repli ci-dessous — les villes les plus peuplées — était
 * la seule chose qu'un crawler voyait, identique sur les 32 728 pages.
 */
export function useMajorCities(
  cityList: string[],
  limit = 12,
  around?: string | null,
  initialData?: string[] | null,
): string[] {
  const normalizedAround =
    typeof around === "string" && around.trim().length > 0
      ? around.trim()
      : null;
  const { data: featured } = useFeaturedCities({
    limit,
    around: normalizedAround,
    initialData,
  });

  return useMemo(() => {
    if (featured && featured.length > 0) {
      return featured;
    }

    return cityList.slice(0, limit);
  }, [cityList, featured, limit]);
}
